import {
  Tab,
  Tabs,
  Container,
  Button,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Navigate, useNavigate } from "react-router-dom";

import { useOrgConfig } from "~/providers/OrgConfigProvider";
import VisitType from "./VisitType";
import { useState } from "react";
import CreateVisitTypeDialog from "./CreateVisitTypeDialog";

interface TabVisitTypesProps {
  id?: number;
}

const TabVisitTypes = ({ id }: TabVisitTypesProps) => {
  const { visitTypes } = useOrgConfig();
  const navigate = useNavigate();
  const [createVisitTypeDialogOpen, setCreateVisitTypeDialogOpen] = useState(false);

  const tab = id;
  if (!tab) {
    const visitTypeId = Object.values(visitTypes)[0]?.id;
    if (visitTypeId) {
      return <Navigate to={`/operate-config/visit-types/${visitTypeId}`} replace />;
    }
  }

  return <Container maxWidth={false} sx={{ mt: 4, mb: 4 }}>
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 4, lg: 3, xl: 2 }}>
        <Tabs value={tab} onChange={(_, newValue) => { navigate(`/operate-config/visit-types/${newValue}`); }} orientation="vertical" variant="scrollable" sx={{ maxHeight: 400, ".MuiTabScrollButton-root": { display: "none" } }} visibleScrollbar={true}>
          {Object.values(visitTypes).map((vt) => <Tab key={vt?.id} label={vt?.name} value={vt?.id} />)}
        </Tabs>
        <Button
          variant="contained"
          fullWidth
          sx={{ mt: 2 }}
          onClick={() => {
            setCreateVisitTypeDialogOpen(true);
          }}
        >
          Create Visit Type
        </Button>

        <CreateVisitTypeDialog
          open={createVisitTypeDialogOpen}
          onClose={() => setCreateVisitTypeDialogOpen(false)}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 8, lg: 9, xl: 10 }}>
        {tab && visitTypes[tab] && <VisitType key={tab} visitTypeId={tab} />}
      </Grid>
    </Grid>
  </Container>
}

export default TabVisitTypes;
